import upsell from 'src/js/modules/upsell';

function getPageSettingsTraits(pageSettings, { displayInNavigation } = {}) {
  const {
    name,
    htmlLocale,
    password,
    description,
    openGraphDescription,
    usePageDescriptionForOgDescription,
    openGraphTitle,
    usePageTitleForOgTitle,
    openGraphImage,
    keywords,
    preventIndexing,
    footerCode,
    headCode,
    headerCode,
  } = pageSettings;

  return {
    pageName: name,
    displayInNavigation,
    languageCode: htmlLocale,
    pageAccess: password ? 'password-protected' : 'open-for-everyone',
    pageProtectedAvailable: upsell.verifiers.isFeatureAvailable(
      upsell.features.PASSWORD_PROTECTED_PAGES
    ),
    metaDescriptionAdded: Boolean(description && description.trim()),
    metaKeywordsAdded: Boolean(keywords && keywords.trim()),
    ogTitleAdded: Boolean(openGraphTitle && openGraphTitle.trim()),
    ogTitleInheritSEO: Boolean(usePageTitleForOgTitle),
    ogDesrciptionAdded: Boolean(openGraphDescription && openGraphDescription.trim()),
    ogDesrciptionInheritSEO: Boolean(usePageDescriptionForOgDescription),
    ogImageAdded: Boolean(openGraphImage),
    customCodeAdded: Boolean(footerCode || headCode || headerCode),
    hiddenFromSearch: Boolean(preventIndexing),
  };
}

export default getPageSettingsTraits;
